var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return (_vm.itemKey
  ? _vm.insertVisible != null && _vm.insertVisible[_vm.itemKey] != null
    ? _vm.insertVisible[_vm.itemKey]
    : false
  : true)
    ? _c(
        "b-col",
        { attrs: { cols: "12", md: _vm.md, lg: _vm.lg } },
        [
          _c(
            "b-form-group",
            {
              class: { "form-group--error": _vm.itemError },
              scopedSlots: _vm._u(
                [
                  {
                    key: "label",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.itemTitle + (_vm.itemRequired ? " *" : "")
                            ) +
                            "\n        "
                        ),
                        _c("b-popover", {
                          attrs: {
                            show: _vm.showCopiedMessage,
                            title: _vm.copiedMessage,
                            placement: "top",
                            target: "copy-area"
                          },
                          on: {
                            "update:show": function($event) {
                              _vm.showCopiedMessage = $event
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.showCopy
                          ? _c(
                              "span",
                              {
                                staticClass: "form-group-copy",
                                attrs: { id: "copy-area" },
                                on: {
                                  click: function($event) {
                                    return _vm.copy()
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-copy" })]
                            )
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                4246912931
              )
            },
            [_vm._v(" "), _vm._t("default")],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-859bcb30", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-859bcb30","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NextFormGroup.vue
// module id = null
// module chunks = 